import { useState } from 'react';

export default useState;
